import { useState, useEffect, useMemo } from 'react';
import { getSymbols } from '../services/SymbolsService';
import Select from 'react-select/creatable';

/**
 * props:
 * - symbol
 * - disabled
 * - onChange
 * - onlyFutures
 * - allowedSymbols (array de símbolos permitidos - se fornecido, filtra a lista)
 */
function SelectSymbol(props) {

    const [symbols, setSymbols] = useState([]);
    const [isDisabled, setIsDisabled] = useState(true); // desabilita enquanto carrega
    const [value, setValue] = useState(null);

    useEffect(() => {
        setValue({ label: props.symbol, value: props.symbol });
    }, [props.symbol])

    useEffect(() => {
        setIsDisabled(props.disabled);
    }, [props.disabled])

    useEffect(() => {
        getSymbols()
            .then(symbolObjects => {
                let symbolNames = symbolObjects.rows ? symbolObjects.rows.map(s => s.symbol) : symbolObjects.map(s => s.symbol);

                if (symbolNames.length) {
                    if (props.onlyFutures)
                        symbolNames = symbolNames.filter(s => /(BUSD|USDT)$/.test(s));
                    
                    // Se allowedSymbols foi fornecido, filtra a lista
                    if (props.allowedSymbols !== undefined) {
                        if (props.allowedSymbols.length === 0) {
                            // Se o array está vazio, não mostra nenhum símbolo
                            symbolNames = [];
                        } else {
                            symbolNames = symbolNames.filter(s => props.allowedSymbols.includes(s));
                        }
                    }
                        
                    setSymbols(symbolNames.map(s => {
                        return {
                            value: s, label: s
                        }
                    }));
                    setIsDisabled(props.disabled || false); // habilita quando carrega (a menos que esteja desabilitado via props)
                }
                else {
                    setSymbols([{ value: "NO_SYMBOLS", label: "No symbols available" }]);
                    setIsDisabled(true);
                }
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setSymbols([{ value: "ERROR", label: "Error loading symbols" }]);
                setIsDisabled(true);
            })
    }, [props.onlyFutures, props.allowedSymbols])

    function onSymbolChange(event) {
        props.onChange({ target: { id: 'symbol', value: event.value } });
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: 220,
            backgroundColor: 'rgba(37, 37, 37, 0.8)',
            border: state.isFocused ? '1px solid #8c66fc' : '1px solid rgba(140, 102, 252, 0.3)',
            borderRadius: '10px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(140, 102, 252, 0.2)' : 'none',
            '&:hover': {
                border: '1px solid #8c66fc'
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#252525',
            border: '1px solid rgba(140, 102, 252, 0.3)',
            borderRadius: '10px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
            zIndex: 9999
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected 
                ? 'rgba(140, 102, 252, 0.3)' 
                : state.isFocused 
                    ? 'rgba(140, 102, 252, 0.2)' 
                    : 'rgba(26, 26, 26, 0.5)',
            color: state.isSelected || state.isFocused ? '#ffffff' : '#e0e0e0',
            cursor: 'pointer',
            '&:active': {
                backgroundColor: 'rgba(140, 102, 252, 0.3)'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#ffffff',
            fontWeight: 600
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#a0a0a0'
        }),
        input: (provided) => ({
            ...provided,
            color: '#ffffff'
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: 'rgba(140, 102, 252, 0.3)'
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: state.isFocused ? '#ffffff' : '#8c66fc',
            '&:hover': {
                color: '#ffffff'
            }
        }),
        clearIndicator: (provided) => ({
            ...provided,
            color: '#8c66fc',
            '&:hover': {
                color: '#ffffff'
            }
        })
    }

    const selectSymbol = useMemo(() => {
        return (
            <Select
                value={value}
                isDisabled={isDisabled}
                styles={customStyles}
                onChange={onSymbolChange}
                options={symbols} />
        )
    }, [symbols, value, isDisabled])

    return (selectSymbol);
}

export default SelectSymbol;